<script setup lang="ts">

</script>

<template>
  <div class="bg-primary rounded-md px-2">
    <label class="font-black text-[#FBDE39] text-xs flex items-center">
      NEW ✨
    </label>
  </div>
</template>

<style scoped>

</style>
